import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.css";

const TwoColsWithTopBarLayout = ({ children }) => (
  <div className={`${style.outer} translate`}>
    <div className={style.topRow}>{children[0]}</div>
    <div className={style.col1}>{children[1]}</div>
    <div className={style.col2}>{children[2]}</div>
  </div>
);
TwoColsWithTopBarLayout.propTypes = {
  content: PropTypes.element,
  props: PropTypes.object
};

export default TwoColsWithTopBarLayout;
